import { useMutation } from '@apollo/client'
import { CountrySelect, LanguageSelect, ModalForm, TextInput, useForm, yup } from '@faceup/form'
import { Country, Language, SHORT_STRING_MAX_LENGTH } from '@faceup/utils'
import { graphql } from '../__generated__'

const mutations = {
  RequestLiveHotlineOrder: graphql(`
    mutation RequestLiveHotlineOrder($input: RequestLiveHotlineOrderInput!) {
      requestLiveHotlineOrder(input: $input) {
        success
      }
    }
  `),
}

const schema = yup.object({
  name: yup.string().required().max(SHORT_STRING_MAX_LENGTH),
  language: yup.mixed<Language>().oneOf(Object.values(Language)).required(),
  country: yup.mixed<Country>().oneOf(Object.values(Country)).required(),
})

type CreateLiveHotlineModalProps = {
  open: boolean
  onClose: () => void
  institutionId: string
}

export const CreateLiveHotlineModal = ({
  open,
  onClose,
  institutionId,
}: CreateLiveHotlineModalProps) => {
  const form = useForm({
    schema,
    afterSubmit: 'resetValues',
  })

  const [requestLiveHotlineOrder] = useMutation(mutations.RequestLiveHotlineOrder, {
    refetchQueries: ['ReportSourcesQuery'],
    onCompleted: () => {
      onClose()
    },
  })

  return (
    <ModalForm
      form={form}
      submitButtonText='add'
      title='Request live hotline'
      open={open}
      onSubmit={async values => {
        const result = await requestLiveHotlineOrder({
          variables: {
            input: {
              motherId: institutionId,
              name: values.name,
              country: values.country,
              language: values.language,
            },
          },
        })
        if (result.errors) {
          return false
        }
        return true
      }}
      onClose={onClose}
    >
      <TextInput control={form.control} name='name' label='Name' />
      <LanguageSelect control={form.control} name='language' label='Language' />
      <CountrySelect control={form.control} name='country' label='Country' />
    </ModalForm>
  )
}
